/**
 * The mother of all exceptions which basically tells us that we are not using something as originally intended 😉.
 *
 * Note: It can also be that the requirements have changed in the meantime and we might have to remove the usage of this exception.
 */
export class InvalidOperationException extends Error {
  constructor(
    description = "This exception should never be encountered and indicates that there is an error in our code",
  ) {
    super(description);
  }
}
